export default __webpack_public_path__ + "static/media/Diners.5fc0cefb.svg";